import { render } from "./ViewSong.vue?vue&type=template&id=6b0e581c&scoped=true"
import script from "./ViewSong.vue?vue&type=script&lang=js"
export * from "./ViewSong.vue?vue&type=script&lang=js"

import "./ViewSong.vue?vue&type=style&index=0&id=6b0e581c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0e581c"]])

export default __exports__